import { useCallback, useState } from 'react';
import { sdk } from 'src/utilities/sdk';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { ValidateChildCorpNamesResponse } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/types';

export type UseValidateChildCorpNamesReturn = {
  validateChildCorpNames: (childCorpNames: string[]) => void;
  isLoading: boolean;
};

export type UseValidateChildCorpNamesProps = {
  parentCorpId: string;
  onSuccess: (data: ValidateChildCorpNamesResponse) => void;
};
export const useValidateChildCorpNames = ({
  parentCorpId,
  onSuccess,
}: UseValidateChildCorpNamesProps): UseValidateChildCorpNamesReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const mutate = useCallback(
    async (childCorpNames: string[]) => {
      setIsLoading(true);
      try {
        const responseData = await sdk.http.post(
          `/corps/parentcorp/${parentCorpId}/validate_corp_names`,
          childCorpNames
        );

        onSuccess(responseData);
      } catch (error) {
        pushErrorFromAPI(error);
      } finally {
        setIsLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [parentCorpId]
  );

  return {
    validateChildCorpNames: mutate,
    isLoading,
  };
};
